import { Injectable } from '@angular/core';
import { AdminPowerPriceEndpointClient } from '../../../protos/generated/admin.pbsc';
import { AuthService } from '../../../authentication/service/auth.service';
import { GetElPricesByUserIdRequest } from '../../../protos/generated/admin.pb';

export interface GetElectricityPricesParams {
  date: string;
  priceClass: number;
  userId?: number;
}

@Injectable({
  providedIn: 'root'
})

export class AdminPowerPriceService {
  
  constructor(private adminPowerPriceClient: AdminPowerPriceEndpointClient , private authService : AuthService) { }

  getPowerPriceByUserId(date : string , userId : number){
    const metaData = this.authService.getMetadata();
    const request = new GetElPricesByUserIdRequest();
    request.date = date;
    request.userId = userId;
    request.priceClass = 1;

    return this.adminPowerPriceClient.getElectricityPricesByUserId(request , metaData);
  }

}
